var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCampamentos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.5 65",
    style: {
      enableBackground: "new 0 0 64.5 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B7A16B;}\n\t.st1{fill:#675656;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    transform: "translate(-0.477 -0.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    className: "st0",
    d: "M54.6,33.3l-22-18.5l-22,18.5H8.7v31.5h17.6V50.2c0-4.1,2.8-7.3,6.5-7.3s6.5,3.2,6.5,7.3 v14.6h17.6V33.3H54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    className: "st1",
    d: "M61.4,21L37.2,3.2l0,0l-0.6-0.5c-2.3-1.8-5.4-1.8-7.7,0L3.8,21C0.7,23.4-0.1,27.8,2,31.3 c1,1.6,2.6,2.8,4.5,3.2c0.4,0.1,0.8,0.2,1.2,0.1c1.4,0,2.8-0.5,3.9-1.3L30.9,19l1.5-1.2l21.3,15.5c1.1,0.9,2.5,1.3,3.9,1.4 c2.4,0,4.6-1.3,5.8-3.4C65.3,27.8,64.5,23.5,61.4,21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampamentos);
export default __webpack_public_path__ + "static/media/icon-campamentos.04fb912c824835e7cef0deb5b2d8960c.svg";
export { ForwardRef as ReactComponent };